import { render, staticRenderFns } from "./InboxIcon.vue?vue&type=template&id=b5951290"
import script from "./InboxIcon.vue?vue&type=script&lang=js"
export * from "./InboxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports